import { render, staticRenderFns } from "./IngredientsCloud.vue?vue&type=template&id=0da6e7a8&scoped=true"
import script from "./IngredientsCloud.vue?vue&type=script&lang=js"
export * from "./IngredientsCloud.vue?vue&type=script&lang=js"
import style0 from "./IngredientsCloud.vue?vue&type=style&index=0&id=0da6e7a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da6e7a8",
  null
  
)

export default component.exports